import { cancellableGet } from '../../lib/cancellableGet';

/** The factory line's snapshot, pushed by prodqc every minute. Admin-only, read-only. */
const ROOT = '/admin/production';

// Bare object: the snapshot without its three lists, plus received_at and age_seconds.
export const fetchLine = () => cancellableGet(`${ROOT}/line/`);

// Lists page with { success, page, limit, total_records, total_pages, data }, and read
// `page` and `limit` (CoreApi's shared ListQuerySerializer); an unknown param is ignored,
// not refused. Unset filters stay off the wire, since an empty box= would match no row.
const listParams = ({ page = 1, limit, pageSize = 50, ...filters } = {}) => {
  const params = { page, limit: limit || pageSize };
  Object.entries(filters).forEach(([key, value]) => {
    if (value) params[key] = value;
  });
  return params;
};

export const fetchDevices = (query) =>
  cancellableGet(`${ROOT}/devices/`, { params: listParams(query) });

// DeviceRow plus `charger` and `set`, each null until the pair is bound.
export const fetchDevice = (ficr) => cancellableGet(`${ROOT}/devices/${ficr}/`);

export const fetchChargers = (query) =>
  cancellableGet(`${ROOT}/chargers/`, { params: listParams(query) });

// ChargerRow plus `device`, null until bound.
export const fetchCharger = (ficr) => cancellableGet(`${ROOT}/chargers/${ficr}/`);

export const fetchSets = (query) => cancellableGet(`${ROOT}/sets/`, { params: listParams(query) });

// snapshot.quality plus as_of, week and today.
export const fetchQuality = () => cancellableGet(`${ROOT}/quality/`);

// snapshot.benches plus server and as_of.
export const fetchBenches = () => cancellableGet(`${ROOT}/benches/`);
